export const titleName: string = 'V Crew 公式サイト';
export const titleSeparator: string = ' | ';
export const contactUrl: string = 'https://docs.google.com/forms/d/e/1FAIpQLSeLfqkmNX12C6aPW7rjLiZt8BupYdlc8fb4Uex-oz3pAfEiRQ/viewform';
export const companyUrl: string = 'https://cucurucu.love/';